var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeaderboardRank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#EDEFF1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3334 11.8333H19.6109V9.33333C19.6109 9.11232 19.5231 8.90036 19.3668 8.74408C19.2105 8.5878 18.9986 8.5 18.7775 8.5H13.2225C13.0015 8.5 12.7896 8.5878 12.6333 8.74408C12.477 8.90036 12.3892 9.11232 12.3892 9.33333V15.1667H7.66671C7.44569 15.1667 7.23373 15.2545 7.07745 15.4107C6.92117 15.567 6.83337 15.779 6.83337 16V22.6667C6.83337 22.8877 6.92117 23.0996 7.07745 23.2559C7.23373 23.4122 7.44569 23.5 7.66671 23.5H24.3334C24.5544 23.5 24.7664 23.4122 24.9226 23.2559C25.0789 23.0996 25.1667 22.8877 25.1667 22.6667V12.6667C25.1667 12.4457 25.0789 12.2337 24.9226 12.0774C24.7664 11.9211 24.5544 11.8333 24.3334 11.8333ZM12.3892 21.8333H8.50004V16.8333H12.3892V21.8333ZM17.9442 21.8333H14.0559V10.1667H17.9442V21.8333ZM23.5 21.8333H19.6109V13.5H23.5V21.8333Z",
    fill: "#2C3E4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaderboardRank);
export default __webpack_public_path__ + "static/media/leaderboard-rank.b89ccabae6076635e5ed585c46dbf092.svg";
export { ForwardRef as ReactComponent };